import { PUBLIC_URL } from '../../utils/constants';

export default {
  DASHBOARD: `${PUBLIC_URL}/dashboard`,
  HR_DASHBOARD: `${PUBLIC_URL}/hr`,
};
